export const FETCH_TICKETS_REQUEST = 'FETCH_TICKETS_REQUEST';
export const FETCH_TICKETS_SUCCESS = 'FETCH_TICKETS_SUCCESS';
export const FETCH_TICKETS_FAILURE = 'FETCH_TICKETS_FAILURE';

export const FETCH_TICKET_BY_ID_REQUEST = 'FETCH_TICKET_BY_ID_REQUEST';
export const FETCH_TICKET_BY_ID_SUCCESS = 'FETCH_TICKET_BY_ID_SUCCESS';
export const FETCH_TICKET_BY_ID_FAILURE = 'FETCH_TICKET_BY_ID_FAILURE';

export const CREATE_TICKET_REQUEST = 'CREATE_TICKET_REQUEST';
export const CREATE_TICKET_SUCCESS = 'CREATE_TICKET_SUCCESS';
export const CREATE_TICKET_FAILURE = 'CREATE_TICKET_FAILURE';

export const UPDATE_TICKET_REQUEST = 'UPDATE_TICKET_REQUEST';
export const UPDATE_TICKET_SUCCESS = 'UPDATE_TICKET_SUCCESS';
export const UPDATE_TICKET_FAILURE = 'UPDATE_TICKET_FAILURE';

export const FETCH_ARTICLES_REQUEST = 'FETCH_ARTICLES_REQUEST';
export const FETCH_ARTICLES_SUCCESS = 'FETCH_ARTICLES_SUCCESS';
export const FETCH_ARTICLES_FAILURE = 'FETCH_ARTICLES_FAILURE';
export const FETCH_ARTICLE_BY_ID_REQUEST = 'FETCH_ARTICLE_BY_ID_REQUEST';
export const FETCH_ARTICLE_BY_ID_SUCCESS = 'FETCH_ARTICLE_BY_ID_SUCCESS';
export const FETCH_ARTICLE_BY_ID_FAILURE = 'FETCH_ARTICLE_BY_ID_FAILURE';

export const FETCH_FORUM_CATEGORIES_REQUEST = 'FETCH_FORUM_CATEGORIES_REQUEST';
export const FETCH_FORUM_CATEGORIES_SUCCESS = 'FETCH_FORUM_CATEGORIES_SUCCESS';
export const FETCH_FORUM_CATEGORIES_FAILURE = 'FETCH_FORUM_CATEGORIES_FAILURE';
export const FETCH_FORUM_POSTS_REQUEST = 'FETCH_FORUM_POSTS_REQUEST';
export const FETCH_FORUM_POSTS_SUCCESS = 'FETCH_FORUM_POSTS_SUCCESS';
export const FETCH_FORUM_POSTS_FAILURE = 'FETCH_FORUM_POSTS_FAILURE';
export const FETCH_FORUM_POST_BY_ID_REQUEST = 'FETCH_FORUM_POST_BY_ID_REQUEST';
export const FETCH_FORUM_POST_BY_ID_SUCCESS = 'FETCH_FORUM_POST_BY_ID_SUCCESS';
export const FETCH_FORUM_POST_BY_ID_FAILURE = 'FETCH_FORUM_POST_BY_ID_FAILURE';
export const CREATE_FORUM_POST_SUCCESS = 'CREATE_FORUM_POST_SUCCESS';
export const CREATE_FORUM_REPLY_SUCCESS = 'CREATE_FORUM_REPLY_SUCCESS';

